function CustomerHistory({ history }) {
  const items = [
    { label: "Upcoming", value: history.upcoming },
    { label: "Completed", value: history.completed },
    { label: "No Show", value: history.noshow },
    { label: "Cancelled", value: history.cancel },
  ];

  return (
    <div className="ch-row">
      {items.map((item) => (
        <span key={item.label} className={`ch-item${item.value === 0 ? " ch-dim" : ""}`}>
          <span className="ch-count">{item.value}</span>
          <span className="ch-label">{item.label}</span>
        </span>
      ))}
    </div>
  );
}

export default CustomerHistory;
